var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 19.418v2.124A9.998 9.998 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2c1.922 0 3.695.563 5.219 1.5L15.75 4.969C14.629 4.367 13.363 4 12 4a8 8 0 1 0 3 15.418zM19.402 9a8.282 8.282 0 0 0-.34-.719l1.47-1.5A9.998 9.998 0 0 1 21.54 9H19.4zM15 14.647v2.55A6.002 6.002 0 0 1 6 12c0-3.313 2.688-6 6-6 .805 0 1.55.18 2.25.469l-1.594 1.593A3.629 3.629 0 0 0 12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4a3.99 3.99 0 0 0 3-1.353zm5.5-12.553L21.906 3.5l-7.968 8A1.999 1.999 0 0 1 12 14a1.999 1.999 0 1 1 .5-3.938l8-7.968zm1.115 11.62h-.964c-.62 0-.689.215-.689.715v.928h1.447L21.339 17h-1.308v5h-2.204v-5H17v-1.714h.827v-1.072c0-1.428.55-2.214 2.135-2.214h1.653v1.714z",
    id: "target-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#target-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.a0f71f1231a542606af9255e10c113c5.svg";
export { ForwardRef as ReactComponent };